import { bannerImageReducer } from "./BannerImageReducer";
import { currentNewsReducer } from "./CurrentNewsReducer";
import { footerSectionImagesReducer } from "./FooterSectionImagesReducer";
import { heroImageReducer } from "./HeroImageReducer";
import { navigationReducer } from "./NavigationItemsReducer";
import { quickLinksReducer } from "./QuickLinksReducer";
import { recentlyUpdatedFilesReducer } from "./RecentlyUpdatedFilesReducer";
import { recentlyUpdatedPagesReducer } from "./RecentlyUpdatedPagesReducer";
import { TitleTextsReducer } from "./TitleTextReducer";
import { State } from "./Reducers";
import { resourceLinksReducer } from "./ResourceLinksReducer";
import TextSizeReducer from "./TextSizeReducer";
import { SPEnvironmentReducer } from "./SPEnvironmentReducer";
import { HowTosReducer } from "./HowTosReducer";
import { HowToImagesReducer } from "./HowToImagesReducer";

export const commonReducers = {
  resourceLinks: resourceLinksReducer,
  quickLinks: quickLinksReducer,
  image: heroImageReducer,
  bannerImage: bannerImageReducer,
  footerSectionImages: footerSectionImagesReducer,
  navigation: navigationReducer,
  recentlyUpdatedFiles: recentlyUpdatedFilesReducer,
  recentlyUpdatedPages: recentlyUpdatedPagesReducer,
  currentNews: currentNewsReducer,
  State: State,
  textSize: TextSizeReducer,
  titleTexts: TitleTextsReducer, 
  spEnvironment: SPEnvironmentReducer,
  howtos: HowTosReducer,
  howToImages: HowToImagesReducer,
};

export default commonReducers;
